import * as React from 'react';
import { observer } from 'mobx-react';
import { InfoBarShowDetailsAction } from '../schema/InfoBarMessageViewState';
import InfobarShowHideDetailsPart, {
    InfobarShowHideDetailsPartProps,
} from './InfobarShowHideDetailsPart';

export interface InfoBarShowDetailsActionState {
    isShowingDetails: boolean;
}

export interface InfoBarMessageWithShowDetailsActionProps extends InfoBarShowDetailsAction {
    className?: string;
}

@observer
export default class InfoBarMessageWithShowDetailsAction extends React.Component<
    InfoBarMessageWithShowDetailsActionProps,
    InfoBarShowDetailsActionState
> {
    constructor(props: InfoBarMessageWithShowDetailsActionProps) {
        super(props);
        this.state = { isShowingDetails: false };
    }

    private toggleShowingDetails = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        this.setState({ isShowingDetails: !this.state.isShowingDetails });
    };

    render() {
        const { children, ...otherProps } = this.props;

        const infobarShowHideDetailsPartProps: InfobarShowHideDetailsPartProps = {
            ...otherProps,
            clickHandler: this.toggleShowingDetails,
            isShowingDetails: this.state.isShowingDetails,
        };

        return <InfobarShowHideDetailsPart {...infobarShowHideDetailsPartProps} />;
    }
}
